export default "/images/new-item.png?dfd78bacf804f8321ecb4a9914e27b1e";